export default "__VITE_ASSET__Dpjq_bLx__"